export const myCart = "@mycart"

export const setItemToMyCart = (newCart, defaultValue) => localStorage.setItem(myCart, JSON.stringify(newCart ?? defaultValue));